import PropTypes from 'prop-types';

const author = PropTypes.shape({
  id: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  avatar_name: PropTypes.string,
  is_author: PropTypes.bool,
});

export default {
  author,
  authors: PropTypes.arrayOf(PropTypes.oneOfType([author, PropTypes.string])),
};
